var map = {
	"./accessibility.svg": 425,
	"./angle-down.svg": 2957,
	"./backspace.svg": 6600,
	"./cart.svg": 6849,
	"./clock.svg": 2075,
	"./close.svg": 5837,
	"./contrast.svg": 9050,
	"./font-size.svg": 6782,
	"./info.svg": 6947,
	"./key-backspace.svg": 5082,
	"./key-enter.svg": 5801,
	"./key-shift.svg": 5359,
	"./minus.svg": 8441,
	"./plus.svg": 4491,
	"./search.svg": 4343,
	"./tick.svg": 6920,
	"./trash.svg": 6891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;